import { Action, createReducer, on } from '@ngrx/store';

import * as actions from './ui.actions';

export interface UiState {
  isChannelLoaded: boolean;
  isChannelsLoaded: boolean;
  isDarkMode: boolean;
  isLoadingChannels: boolean;
  isLoadingChannel: boolean;
  isAllChannelsLoaded: boolean;
  isLoadingUsers: boolean;
  isCreatingChannel: boolean;
  isLoadingResolve: boolean;
  isLoadingTags: boolean;
  isFullScreenVideoCall: boolean;
  scrollPosition: number;
  showBackArrow: boolean;
  showChannel: boolean;
  showChannels: boolean;
  showChannelsFilters: boolean;
  showProfile: boolean;
  showScrollButton: boolean;
  hideInfoButton: boolean;
  hideInputChat: boolean;
  hideAttachments: boolean;
  hideEditPhone: boolean;
  showSidebar: boolean;
  showStatusBanner: boolean;
  showGoToOrderButton: boolean;
  isLoadingAway: boolean;
}

export const uiInitialState: UiState = {
  isChannelLoaded: false,
  isChannelsLoaded: false,
  isAllChannelsLoaded: false,
  isDarkMode: !localStorage.getItem('data-theme') ? false : localStorage.getItem('data-theme') === 'dark',
  isCreatingChannel: false,
  isLoadingChannels: true,
  isLoadingUsers: false,
  isLoadingResolve: false,
  isLoadingTags: false,
  isLoadingChannel: false,
  isLoadingAway: false,
  isFullScreenVideoCall: false,
  scrollPosition: 1,
  showBackArrow: false,
  hideInputChat: false,
  hideAttachments: false,
  hideEditPhone: false,
  showChannel: true,
  showChannels: false,
  showChannelsFilters: false,
  showProfile: false,
  showScrollButton: false,
  showSidebar: false,
  showStatusBanner: true,
  showGoToOrderButton: false,
  hideInfoButton: false,
};

const _uiReducer = createReducer(
  uiInitialState,
  on(actions.setBackArrow, (state, { value }) => ({ ...state, showBackArrow: value })),
  on(actions.setChannelLoaded, (state, { value }) => ({ ...state, isChannelLoaded: value })),
  on(actions.setChannelsLoaded, (state, { value }) => ({ ...state, isChannelsLoaded: value })),
  on(actions.setDarkmode, (state, { value }) => ({ ...state, isDarkMode: value })),
  on(actions.setLoadingChannel, (state, { value }) => ({ ...state, isLoadingChannel: value })),
  on(actions.setLoadingChannels, (state, { value }) => ({ ...state, isLoadingChannels: value })),
  on(actions.setHideInputChat, (state, { value }) => ({ ...state, hideInputChat: value })),
  on(actions.setCreatingChannel, (state, { value }) => ({ ...state, isCreatingChannel: value })),
  on(actions.setLoadingResolve, (state, { value }) => ({ ...state, isLoadingResolve: value })),
  on(actions.setLoadingTags, (state, { value }) => ({ ...state, isLoadingTags: value })),
  on(actions.setLoadingUsers, (state, { value }) => ({ ...state, isLoadingUsers: value })),
  on(actions.setLoadingChannel, (state, { value }) => ({ ...state, isLoadingChannel: value })),
  on(actions.setShowChannel, (state, { value }) => ({ ...state, showChannel: value })),
  on(actions.setShowChannels, (state, { value }) => ({ ...state, showChannels: value })),
  on(actions.setShowProfile, (state, { value }) => ({ ...state, showProfile: value })),
  on(actions.setShowScrollButton, (state, { value }) => ({ ...state, showScrollButton: value })),
  on(actions.setShowSidebar, (state, { value }) => ({ ...state, showSidebar: value })),
  on(actions.setIsFullScreenVideoCall, (state, { value }) => ({ ...state, isFullScreenVideoCall: value })),
  on(actions.setShowChannelsFilters, (state, { value }) => ({ ...state, showChannelsFilters: value })),
  on(actions.scrollToPosition, (state, { value }) => ({ ...state, scrollPosition: value === 1 ? 0 : 1 })),
  on(actions.setShowStatusBanner, (state, { value }) => ({ ...state, showStatusBanner: value })),
  on(actions.setAllChannelsLoaded, (state, { value }) => ({ ...state, isAllChannelsLoaded: value })),
  on(actions.setShowGoToOrderButton, (state, { value }) => ({ ...state, showGoToOrderButton: value })),
  on(actions.setHideInfoButton, (state, { value }) => ({ ...state, hideInfoButton: value })),
  on(actions.setHideAttachments, (state, { value }) => ({ ...state, hideAttachments: value })),
  on(actions.setHideEditPhone, (state, { value }) => ({ ...state, hideEditPhone: value })),
  on(actions.setIsLoadingAway, (state, { value }) => ({ ...state, isLoadingAway: value })),
  on(actions.setCompleteUIState, (state, { savedState }) => ({
    ...savedState,
  }))
);

export function uiReducer(state: UiState, action: Action) {
  return _uiReducer(state, action);
}
